module.exports = __webpack_public_path__ + "img/logo.26a6b17e.png";